import { useState, useEffect } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const allowedDomain = "getpop.co"; // Your Google Workspace domain
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID; // Store this in .env

  useEffect(() => {
    // Check if user is already authenticated
    if (localStorage.getItem("authenticated") === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSuccess = (response) => {
    const idToken = response.credential; // JWT token from Google
    const payload = JSON.parse(atob(idToken.split(".")[1])); // Decode JWT token

    if (payload.hd === allowedDomain) { // Ensure it's a company email
      localStorage.setItem("authenticated", "true");
      localStorage.setItem("userEmail", payload.email);
      setIsAuthenticated(true);
    } else {
      alert("Unauthorized: Use your company email to sign in.");
    }
  };

  return isAuthenticated ? (
    children
  ) : (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-lg font-bold mb-4">Sign in with Google</h2>
        <GoogleOAuthProvider clientId={clientId}>
          <GoogleLogin onSuccess={handleSuccess} onError={() => alert("Login failed")} />
        </GoogleOAuthProvider>
      </div>
    </div>
  );
};

export default PasswordGate;
